import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSkiNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M9.753 1.811c1.104-2.133 4.14-2.17 5.296-.064L24 18.071l8.952-16.324c1.154-2.106 4.192-2.069 5.295.064l1.117 2.16a7.5 7.5 0 01-.085 7.052L29.71 28.48l9.485 17.297a1.5 1.5 0 01-1.315 2.221h-8a1.5 1.5 0 01-1.315-.779L24 38.895l-4.564 8.325a1.5 1.5 0 01-1.315.78h-8a1.5 1.5 0 01-1.315-2.222l9.485-17.297-9.57-17.458a7.5 7.5 0 01-.085-7.051zm10.249 29.79L12.654 45h4.579l5.056-9.224zm7.996-6.24l2.94-5.362h-4.574l-.653 1.191zm-6.362-5.362h-4.573l3.29 6h4.574zm9.131 25h4.579l-8.774-16h-4.575zM15.418 17h4.573L12.418 3.19 11.301 5.35a4.5 4.5 0 00.05 4.23zm17.164 0l4.067-7.419a4.5 4.5 0 00.05-4.23l-1.117-2.16L28.01 17z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSkiNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSkiNormalLarge;
